import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

type Guid = any;

export class v_InventoryXferHistoryBus extends BaseBus
{
    constructor(busObj: v_InventoryXferHistoryBus = null) {
        super(busObj);
        if (busObj) {
            this.insertDt = DateFunctions.getDate(busObj.insertDt);
            this.updateDt = DateFunctions.getDate(busObj.updateDt);
        }
    }
    CID() {
        return this.inventoryXferHistoryId;
    }
    regionName: String;
    branchName: String;
    branchCode: String;
    inventoryTypeId: Guid;
    inventoryCategoryId: Guid;
    inventorySubCategoryId: Guid;
    manufacturerId: Guid;
    manufacturerTypeId: Guid;
    isActive: Boolean;
    number: String;
    model: String;
    inventoryName: String;
    inventoryDesc: String;
    isPart: Boolean;
    inventoryLocationName: String;
    dispatchNumber: String;
    orderNumber: String;
    orderId: Guid;
    fullname: String;
    inventoryXferHistoryId: Guid;
    companyId: Guid;
    dispatchId: Guid;
    personId: Guid;
    inventoryId: Guid;
    inventoryLocationId: Guid;
    companyBranchId: Guid;
    quantity: number;
    invoiceId: Guid;
    orderReceiveDetailId: Guid;
    sproc: String;
    reason: String;
    qtyAll: number;
    qtyWH: number;
    qtyMain: number;
    orderCost: number;
    ignoreAvgCost: Boolean;
    isWIP: Boolean;
    isDispatch: Boolean;
    isJob: Boolean;
    isContract: Boolean;
    insertUserId: Guid;
    insertDt: Date;
    updateUserId: Guid;
    updateDt: Date;

}
